(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    (function () {
    var notification = document.querySelector('[data-cart-notification]');
    if (!notification) return;

    function formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      return '$' + (cents / 100).toFixed(2);
    }

    function populate(item) {
      if (!item) return;

      var mediaEl = notification.querySelector('[data-cart-notification-media]');
      var titleEl = notification.querySelector('[data-cart-notification-title]');
      var variantEl = notification.querySelector('[data-cart-notification-variant]');
      var priceEl = notification.querySelector('[data-cart-notification-price]');
      var qtyEl = notification.querySelector('[data-cart-notification-quantity]');
      var totalEl = notification.querySelector('[data-cart-notification-total]');

      if (mediaEl) {
        mediaEl.innerHTML = '';
        var imageUrl = item.image
          || (item.featured_image && item.featured_image.url)
          || null;
        if (imageUrl) {
          var img = document.createElement('img');
          img.src = imageUrl;
          img.alt = item.product_title || item.title || '';
          mediaEl.appendChild(img);
        }
      }

      if (titleEl) titleEl.textContent = item.product_title || item.title || '';
      if (variantEl) variantEl.textContent = item.variant_title || '';
      if (priceEl) priceEl.textContent = formatMoney(item.price);
      if (qtyEl) qtyEl.textContent = item.quantity != null ? item.quantity : '';
      if (totalEl) totalEl.textContent = formatMoney(item.line_price);
    }

    function updateCartCount(cart) {
      if (!cart) return;
      var countEls = document.querySelectorAll('[data-cart-count]');
      Array.prototype.forEach.call(countEls, function (el) {
        el.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
      });
    }

    function openBar(item, cart) {
      if (item) populate(item);
      if (cart) updateCartCount(cart);
      notification.classList.add('is-visible');
    }

    function closeBar() {
      notification.classList.remove('is-visible');
    }

    var closeButtons = notification.querySelectorAll('[data-cart-notification-close]');
    Array.prototype.forEach.call(closeButtons, function (btn) {
      btn.addEventListener('click', closeBar);
    });

    window.openCartBar = openBar;
    window.testCartBar = function () { openBar(); };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-overlay"] && !Shopify.designMode) return;
  try {
    (function () {
    var panel = document.querySelector('[data-search-overlay]');
    if (!panel) return;

    var input = panel.querySelector('[data-search-input]');
    var resultsEl = panel.querySelector('[data-search-results]');

    var fetchController = null;
    var debounceTimer = null;

    function openPanel() {
      var mobileMenu = document.querySelector('[data-mobile-menu]');
      if (mobileMenu && typeof mobileMenu.close === 'function' && mobileMenu.open) {
        mobileMenu.close();
      }
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      setTimeout(function () {
        input.focus();
      }, 60);
    }

    function closePanel() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      if (fetchController) {
        fetchController.abort();
        fetchController = null;
      }
      clearTimeout(debounceTimer);
      input.value = '';
      resultsEl.innerHTML = '';
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatPrice(value) {
      if (value == null || value === '') return '';
      if (typeof value === 'number') return '$' + value.toFixed(2);
      var num = parseFloat(value);
      if (isNaN(num)) return '$' + value;
      return '$' + num.toFixed(2);
    }

    function renderResults(data, query) {
      var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      if (products.length === 0) {
        resultsEl.innerHTML = '<p class="search-panel__hint">No matches yet — try a different word.</p>';
        return;
      }

      var html = '<ul class="search-panel__list" role="list">';
      products.forEach(function (p) {
        var img = p.image
          ? '<span class="search-panel__media"><img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy"></span>'
          : '<span class="search-panel__media"></span>';
        var vendor = p.vendor ? '<span class="search-panel__vendor">' + escapeHtml(p.vendor) + '</span>' : '';
        html +=
          '<li class="search-panel__item">' +
            '<a href="' + escapeHtml(p.url || '#') + '" class="search-panel__link">' +
              img +
              '<span class="search-panel__meta">' +
                '<span class="search-panel__title">' + escapeHtml(p.title || '') + '</span>' +
                vendor +
              '</span>' +
              '<span class="search-panel__price">' + formatPrice(p.price) + '</span>' +
            '</a>' +
          '</li>';
      });
      html += '</ul>';

      html +=
        '<p class="search-panel__view-all-wrap">' +
          '<a class="search-panel__view-all" href="/search?q=' + encodeURIComponent(query) + '">' +
            'View all results' +
          '</a>' +
        '</p>';

      resultsEl.innerHTML = html;
    }

    function performSearch(query) {
      if (fetchController) fetchController.abort();
      fetchController = new AbortController();

      var url = '/search/suggest.json?' +
        'q=' + encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor';

      fetch(url, { signal: fetchController.signal, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { renderResults(data, query); })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          console.error('Predictive search failed:', err);
          resultsEl.innerHTML = '<p class="search-panel__hint">Search is temporarily unavailable.</p>';
        });
    }

    function handleInput() {
      var query = input.value.trim();
      clearTimeout(debounceTimer);
      if (query.length === 0) {
        if (fetchController) fetchController.abort();
        resultsEl.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(function () {
        performSearch(query);
      }, 220);
    }

    var openBtns = document.querySelectorAll('[data-search-open]');
    Array.prototype.forEach.call(openBtns, function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openPanel();
      });
    });

    var closeBtns = panel.querySelectorAll('[data-search-close]');
    Array.prototype.forEach.call(closeBtns, function (btn) {
      btn.addEventListener('click', closePanel);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        closePanel();
      }
    });

    /* Click outside the panel closes it — but ignore clicks on the trigger itself */
    document.addEventListener('click', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (panel.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-search-open]')) return;
      closePanel();
    });

    input.addEventListener('input', handleInput);
  })();
  } catch(e) { console.error(e); }
})();

})();
